// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3wv3m","overflowing":"ReadFullNote_overflowing__3Vv3j"};